
import { z } from "zod";

export const EscrowVendorValues = ["PAY_KEEPER"] as const;
export const EscrowVendorSchema = /* @__PURE__ */ z.enum(EscrowVendorValues);
export const EscrowVendor: (typeof EscrowVendorSchema)["enum"] = { "PAY_KEEPER": "PAY_KEEPER" };
export type EscrowVendor = (typeof EscrowVendorValues)[number];
export const EscrowVendorDisplayNames = { "PAY_KEEPER": "Pay Keeper", } satisfies Record<EscrowVendor, string>;
